import * as React from "react";
import { UserArea } from "../../../models/UserArea";
import { UserAreaPermissions } from "../../../models/UserAreaPermissions";
import { TripleSelectBox, TripleSelectBoxOption } from "./TripleSelectBox/TripleSelectBox"
import { UserDetails } from "../../../models/UserDetails";
import { hasEditProjectsAccess } from "../shared/helpers";

interface Props {
    options: any[];
    disabled: boolean;
    selected: { id: number, permissions: UserAreaPermissions }[];
    onChange: (selected: { id: number, permissions: UserAreaPermissions }[]) => void;
    onRemove: (selected: { id: number, permissions: UserAreaPermissions }[]) => void;
    inherited: { id: number, permissions: UserAreaPermissions }[];
    userAreas: UserArea[];
    users: UserDetails[];
}

interface State {
}

export class UserAreaListBox extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
        };

        this.onChange = this.onChange.bind(this);
        this.isReadWrite = this.isReadWrite.bind(this);
        this.isViewOnly = this.isViewOnly.bind(this);

        this.moveToLeft = this.moveToLeft.bind(this);
        this.moveToCenter = this.moveToCenter.bind(this);
        this.moveToRight = this.moveToRight.bind(this);

        this.disableInheritedOptions = this.disableInheritedOptions.bind(this);
        this.canAssignEdit = this.canAssignEdit.bind(this);
    }

    disableInheritedOptions(id: number): boolean {
        return this.props.inherited && this.props.inherited.map(o => o.id).indexOf(id) > -1;
    }

    getOptions(options: any): TripleSelectBoxOption[] {
        return options.map(o => ({ label: o.label, value: o.value } as any) as TripleSelectBoxOption)
    }

    isReadWrite(option: TripleSelectBoxOption): boolean {
        const { selected } = this.props;
        return selected.some(s => s.id === option.value && s.permissions === UserAreaPermissions.ReadWrite);
    }

    isViewOnly(option: TripleSelectBoxOption): boolean {
        const { selected } = this.props;
        return selected.some(s => s.id === option.value && s.permissions === UserAreaPermissions.ViewOnly);
    }

    onChange = (selected: { id: number, permissions: UserAreaPermissions }[]) => {
        this.props.onChange(selected);
    };

    moveToLeft(options: TripleSelectBoxOption[]) {
        const optionsToRemove = options.map(o => ({ id: o.value } as any));
        this.props.onRemove(optionsToRemove)
    }

    moveToCenter(options: TripleSelectBoxOption[]) {
        const updated = options.map(o => ({ id: o.value, permissions: UserAreaPermissions.ReadWrite } as any));
        this.onChange(updated);
    }

    moveToRight(options: TripleSelectBoxOption[]) {
        const updated = options.map(o => ({ id: o.value, permissions: UserAreaPermissions.ViewOnly } as any));
        this.onChange(updated);
    }

    canAssignEdit(ids: number[]): boolean {
        const { users } = this.props;

        return ids.every(id => {
            const user = users.find(u => u.userID == id);

            return hasEditProjectsAccess(user.profile);
        });
    }

    render() {
        const options = this.getOptions(this.props.options);

        return (
            <TripleSelectBox
                options={options}
                selected={this.props.selected}
                isCenter={this.isReadWrite}
                isRight={this.isViewOnly}
                leftTitle="Available"
                centerTitle="Selected (Edit)"
                rightTitle="Selected (View Only)"
                disabled={this.props.disabled}
                moveToLeft={this.moveToLeft}
                moveToCenter={this.moveToCenter}
                moveToRight={this.moveToRight}
                disabledOption={this.disableInheritedOptions}
                moveToCenterDisabled={(ids) => !this.canAssignEdit(ids)}
            />
        );
    }
}
